import React from "react";
import PropTypes from "prop-types";
import C from "../../constants";
import FileDropzone from "../files/FileDropzone";
import _ from 'lodash';
import { mimeTypes } from '../../helpers/strings'; 
import { isMobile, isTablet, isIOS, isAndroid } from "react-device-detect";

const uuidv4 = require("uuid/v4/");

class CaptureAudio extends React.Component {
    constructor(props) {
        super(props);
        this.audioInput = React.createRef();
        this.recordAudio = this.recordAudio.bind(this);
        this.handleFileSelection = this.handleFileSelection.bind(this);
    }

    recordAudio() {
        this.context.store.dispatch({ type: C.START_LOADING });

        var event = new MouseEvent("click", { bubbles: true });
        this.audioInput.current.dispatchEvent(event);
    }

    handleDeviceInput(evt, processAudio) {
        evt.preventDefault();
        if (evt.target.files.length === 0) {
            this.context.store.dispatch({ type: C.STOP_LOADING });
            return;
        }
        let file = evt.target.files[0];
        this.handleProcessAudio(file, processAudio);
    }

    handleProcessAudio(file, processAudio) {
        file.uuid = uuidv4();
        processAudio(file, false, true);
    }

    handleFileSelection(filesArr) {
        if (_.isEmpty(filesArr)){
            return;
        }
        const file = filesArr[0]; //Only allowing 1 file selection at the moment.
        this.context.store.dispatch({ type: C.START_LOADING });
        this.handleProcessAudio(file, this.props.processAudio);
    }

    render() {
        const inputStyle = { display: "none" };
        const acceptTypes = _.join(mimeTypes.AUDIO, ",");
        const isDesktopDevice = !isIOS && !isAndroid && !isMobile && !isTablet;

        return (
            isDesktopDevice ? 
            <FileDropzone handleSelection={this.handleFileSelection} accept={acceptTypes} {...this.props}/>
            :
            <div>
                <input type="file" ref={this.audioInput} accept={acceptTypes} capture id="capture" style={inputStyle}
                    onChange={evt => {
                        this.handleDeviceInput(evt, this.props.processAudio);
                    }}
                />
                <button
                    className="w3-button w3-block w3-indigo w3-round-xxlarge w3-large"
                    onClick={() => {
                        this.recordAudio();
                    }}
                >
                    {this.props.label}
                </button>
            </div>
        );
    }
}

CaptureAudio.propTypes = {
    store: PropTypes.object,
    processAudio: PropTypes.func
};

CaptureAudio.contextTypes = {
    store: PropTypes.object,
};

export default CaptureAudio;
